export default {
  createList(key, limit) {
    return {
      get() {
        return JSON.parse(localStorage.getItem(key) || '[]')
      },
      push(item) {
        const ls = this.get()
        if (typeof item === 'object' && item.id) {
          const objIndex = ls.findIndex((l) => l.id === item.id)
          if (objIndex !== -1) {
            ls.splice(objIndex, 1)
          }
        } else {
          while (ls.indexOf(item) !== -1) {
            ls.splice(ls.indexOf(item), 1)
          }
        }

        ls.unshift(item)
        while (ls.length > limit) {
          ls.pop()
        }
        localStorage.setItem(key, JSON.stringify(ls))
      }
    }
  },

  createItem(key, defaultValue) {
    return {
      get() {
        return localStorage.getItem(key) || defaultValue
      },
      set(value) {
        localStorage.setItem(key, value)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/LocalStore.js